document.addEventListener("DOMContentLoaded", () => {
  //------------------------------------
  const headerLogo = document.querySelector(".header__logo-image");
  if (window.scrollY > 0) {
    headerLogo.classList.add("small");
    headerLogo.classList.remove("large");
  } else {
    headerLogo.classList.add("large");
    headerLogo.classList.remove("small");
  }

  window.addEventListener("scroll", () => {
    const header = document.querySelector(".header__wrapper");

    if (window.scrollY > 0) {
      header.style.padding = "8px 0";
      headerLogo.classList.add("small");
      headerLogo.classList.remove("large");
    } else {
      header.style.padding = "20px 0";
      headerLogo.classList.add("large");
      headerLogo.classList.remove("small");
    }
  });

  // Remove FSB container if present
  let time = 0;
  const hTime = setInterval(() => {
    const fsb = document.querySelector("#fsb_container");
    if (fsb) {
      clearInterval(hTime);
      fsb.remove();
    } else if (time > 300) {
      clearInterval(hTime);
    }
    time++;
  }, 100);

  // Initialize spinners based on cart data
  const cartItems = JSON.parse(localStorage.getItem("cart") || "[]");
  document.querySelectorAll(".spinner-atc").forEach(async (spinnerATC) => {
    spinnerATC.classList.add("initing");
    const currentId = parseInt(spinnerATC.getAttribute("variant_id"));

    for (const cartItem of cartItems) {
      if (cartItem.id === currentId) {
        updateQuantity(cartItem.quantity, spinnerATC, true, 0);
        spinnerATC.classList.remove("initing");
        spinnerATC.querySelector(".atc").classList.remove("show");
        spinnerATC
          .querySelector(".quantity-input-by-spinner")
          ?.classList.add("show");
        return;
      }
    }
    spinnerATC.classList.remove("initing");
  });

  // Handle spinner click events
  document.addEventListener("click", async (e) => {
    const spinnerATC = e.target.closest(".spinner-atc");
    if (spinnerATC) {
      // Don't process clicks if spinner is in loading state
      if (spinnerATC.classList.contains("loading")) {
        return;
      }

      if (e.target.classList.contains("atc")) {
        // Add to cart button clicked
        updateQuantity(1, spinnerATC, false, 1);
      } else if (
        e.target.classList.contains("quantity") &&
        e.target.tagName.toLowerCase() === "p"
      ) {
        // Switch to direct input mode
        spinnerATC
          .querySelector(".quantity-input-by-spinner")
          ?.classList.remove("show");
        spinnerATC.querySelector(".quantity-by-input")?.classList.add("show");
      } else if (
        e.target.classList.contains("minus") ||
        e.target.closest(".minus")
      ) {
        // Decrease quantity
        const quantityLabel = e.target
          .closest(".quantity-input-by-spinner")
          ?.querySelector(".quantity");
        if (quantityLabel) {
          let currentQuantity = parseInt(quantityLabel.getAttribute("value"));
          if (!isNaN(currentQuantity) && currentQuantity > 0) {
            currentQuantity--;
            updateQuantity(currentQuantity, spinnerATC, true, 2);
          }
        }
      } else if (
        e.target.classList.contains("plus") ||
        e.target.closest(".plus")
      ) {
        // Increase quantity
        const quantityLabel = e.target
          .closest(".quantity-input-by-spinner")
          ?.querySelector(".quantity");
        if (quantityLabel) {
          const maxQuantity = parseInt(spinnerATC.getAttribute("max"));
          let currentQuantity = parseInt(quantityLabel.getAttribute("value"));
          if (!isNaN(currentQuantity) && currentQuantity < maxQuantity) {
            currentQuantity++;
            updateQuantity(currentQuantity, spinnerATC, true, 2);
          } else if (
            !isNaN(currentQuantity) &&
            currentQuantity >= maxQuantity
          ) {
            // Show error when max quantity is reached
            const errorMessage = getTranslation(spinnerATC, "max-qty-error", {
              "%MAX%": maxQuantity,
            });
            showNotification("error", errorMessage);
          }
        }
      } else if (
        e.target.classList.contains("check") ||
        e.target.closest(".check")
      ) {
        // Confirm direct quantity input
        const quantityInput = spinnerATC.querySelector("input.quantity");
        if (quantityInput) {
          let currentQuantity = parseInt(quantityInput.value);
          const maxQuantity = parseInt(spinnerATC.getAttribute("max"));
          const quantityLabel = spinnerATC.querySelector("p.quantity");
          const beforeQuantity = parseInt(quantityLabel.getAttribute("value"));

          if (isNaN(currentQuantity) || currentQuantity < 0) {
            // Invalid input (negative or not a number)
            const errorMessage = getTranslation(
              spinnerATC,
              "invalid-qty-error",
            );
            showNotification("error", errorMessage);
            quantityInput.value = beforeQuantity;
          } else if (currentQuantity > maxQuantity) {
            // Exceeds max quantity
            const errorMessage = getTranslation(spinnerATC, "max-qty-error", {
              "%MAX%": maxQuantity,
            });
            showNotification("error", errorMessage);
            quantityInput.value = beforeQuantity;
          } else {
            updateQuantity(currentQuantity, spinnerATC, false, 2);
          }
        }
      }
    }

    // Handle item removal from cart
    if (e.target.classList.contains("line-item__remove-button")) {
      const href = e.target.href;
      const i = href.indexOf("?id=");
      const j = href.indexOf(":", i);
      const id = href.substring(i + 4, j);
      const spinner = document.querySelector(
        `.spinner-atc[variant_id="${id}"]`,
      );
      if (spinner) {
        updateQuantity(0, spinner, false, 0);
      }
    }
  });
});

/**
 * Get translated message from spinner's hidden translations div
 * @param {HTMLElement} spinner - The spinner element
 * @param {string} key - Translation key (without 'data-' prefix)
 * @param {Object} replacements - Values to replace in the translation string
 * @returns {string} - Translated message
 */
const getTranslation = (spinner, key, replacements = {}) => {
  const translationsEl = spinner.querySelector(".spinner-translations");
  if (!translationsEl) return "";

  let message = translationsEl.getAttribute(`data-${key}`) || "";

  // Replace any placeholders in the message
  Object.keys(replacements).forEach((placeholder) => {
    message = message.replace(placeholder, replacements[placeholder]);
  });

  return message;
};

/**
 * Show notification using theme's cart-notification element
 * @param {string} status - 'success' or 'error'
 * @param {string} message - Message to display
 */
const showNotification = (status, message) => {
  const cartNotification = document.querySelector("cart-notification");
  if (!cartNotification) return;

  cartNotification.hidden = false;

  if (status === "error") {
    cartNotification.classList.add("cart-notification--error");
    cartNotification.innerHTML = `
      <div class="cart-notification__overflow">
        <div class="container">
          <div class="cart-notification__wrapper">
            <svg focusable="false" width="20" height="20" class="icon icon--cart-notification" viewBox="0 0 20 20">
              <rect width="20" height="20" rx="10" fill="currentColor"></rect>
              <path d="M9.6748 13.2798C9.90332 13.0555 10.1763 12.9434 10.4937 12.9434C10.811 12.9434 11.0819 13.0555 11.3062 13.2798C11.5347 13.5041 11.6489 13.7749 11.6489 14.0923C11.6489 14.4097 11.5347 14.6847 11.3062 14.9175C11.0819 15.146 10.811 15.2603 10.4937 15.2603C10.1763 15.2603 9.90332 15.146 9.6748 14.9175C9.45052 14.6847 9.33838 14.4097 9.33838 14.0923C9.33838 13.7749 9.45052 13.5041 9.6748 13.2798ZM9.56689 12.1816V5.19922H11.4141V12.1816H9.56689Z" fill="rgb(var(--error-color))"></path>
            </svg>

            <div class="cart-notification__text-wrapper">
              <span class="cart-notification__heading heading">${message}</span>
            </div>
          </div>
        </div>
      </div>
    `;
  } else {
    cartNotification.classList.remove("cart-notification--error");
    cartNotification.innerHTML = `
      <div class="cart-notification__overflow">
        <div class="container">
          <div class="cart-notification__wrapper">
            <svg focusable="false" width="20" height="20" class="icon icon--cart-notification" viewBox="0 0 20 20">
              <rect width="20" height="20" rx="10" fill="currentColor"></rect>
              <path d="M6 10L9 13L14 7" fill="none" stroke="rgb(var(--success-color))" stroke-width="2"></path>
            </svg>

            <div class="cart-notification__text-wrapper">
              <span class="cart-notification__heading heading hidden-phone">${window.themeVariables.strings.cartItemAdded}</span>
              <span class="cart-notification__heading heading hidden-tablet-and-up">${window.themeVariables.strings.cartItemAddedShort}</span>
              <a href="${window.themeVariables.routes.cartUrl}" class="cart-notification__view-cart link" data-no-instant>${window.themeVariables.strings.cartViewCart}</a>
            </div>
          </div>
        </div>
      </div>
    `;
  }
};

/**
 * Update item quantity in spinner and cart
 * @param {number} quantity - The new quantity
 * @param {HTMLElement} spinner - The spinner element
 * @param {boolean} isSpinner - Whether update came from spinner controls
 * @param {number} shouldAdd - 0: just update UI, 1: add to cart, 2: update existing item
 */
const updateQuantity = (quantity, spinner, isSpinner, shouldAdd) => {
  if (!(spinner instanceof HTMLElement) || typeof quantity !== "number") return;

  const maxQuantity = parseInt(spinner.getAttribute("max"));
  const hasAnimation = spinner.querySelector(".animation") !== null;

  if (isNaN(maxQuantity) || quantity > maxQuantity || quantity < 0) return;

  const quantityLabel = spinner.querySelector("p.quantity");
  const quantityInput = spinner.querySelector("input.quantity");

  if (!quantityLabel || !quantityInput) return;

  // Always update the UI immediately to provide instant feedback
  quantityLabel.setAttribute("value", quantity);
  quantityLabel.innerHTML = quantity;
  quantityInput.value = quantity;

  // Handle cart operations
  if (quantity === 0) {
    // Remove item case
    if (hasAnimation) {
      spinner.classList.add("loading");
      console.log("Adding loading class for remove item");
    }

    // Perform cart action immediately without waiting for animation
    removeItem(spinner.getAttribute("variant_id"), { isSpinner });

    // If animation is enabled, remove loading class after animation completes
    if (hasAnimation) {
      setTimeout(() => {
        spinner.classList.remove("loading");
        console.log("Removing loading class after timeout");
      }, 1000); // Increased timeout for better visibility
    }
  } else if (shouldAdd > 0) {
    // Add or update item case
    if (hasAnimation) {
      spinner.classList.add("loading");
      console.log("Adding loading class for add/update item");
    }

    // Perform cart action immediately without waiting for animation
    if (shouldAdd === 1) {
      addToCart(spinner.getAttribute("variant_id"), { isSpinner, quantity });
    } else if (shouldAdd === 2) {
      updateItem(spinner.getAttribute("variant_id"), quantity, { isSpinner });
    }

    // If animation is enabled, remove loading class after animation completes
    if (hasAnimation) {
      setTimeout(() => {
        spinner.classList.remove("loading");
        console.log("Removing loading class after timeout");
      }, 1000); // Increased timeout for better visibility
    }
  }
};

/**
 * Update item quantity in cart
 */
const updateItem = (id, quantity, { isSpinner }) => {
  const spinner = document.querySelector(`.spinner-atc[variant_id="${id}"]`);
  const lineItems = document.querySelectorAll(".line-item");
  let foundItem = false;

  // Find the item in the cart and update it
  for (const lineItem of lineItems) {
    const imagewrapper = lineItem.querySelector(".line-item__image-wrapper");
    if (!imagewrapper) continue;

    const href = imagewrapper.href;
    if (href.indexOf(`?variant=${id}`) !== -1) {
      foundItem = true;
      const quantityInput = lineItem.querySelector(".quantity-selector__input");

      // Store the original quantity in case we need to revert on error
      const originalQuantity = parseInt(quantityInput.value);

      // Update quantity
      quantityInput.value = quantity;
      quantityInput.dispatchEvent(
        new Event("change", {
          bubbles: true,
          cancelable: false,
        }),
      );

      // Monitor the update process
      const loadIcon = lineItem.querySelector(".line-item__loader");
      let isUpdating = 0;
      const updateMonitor = setInterval(() => {
        if (!loadIcon.hasAttribute("hidden") && isUpdating === 0) {
          isUpdating = 1;
        } else if (loadIcon.hasAttribute("hidden") && isUpdating === 1) {
          clearInterval(updateMonitor);

          // Check if there's an error message displayed
          const errorElement = lineItem.querySelector(
            ".line-item__error-message:not([hidden])",
          );
          if (errorElement) {
            // Error found, show notification
            showNotification("error", errorElement.textContent.trim());

            // Reset spinner to original state
            if (spinner) {
              updateQuantity(originalQuantity, spinner, false, 0);
            }
          } else {
            // Success, update spinner
            document.dispatchEvent(
              new CustomEvent("line-item:update", {
                detail: { id, isSpinner, quantity },
              }),
            );
          }
        }
      }, 100);

      break;
    }
  }

  // If the item wasn't found in the cart, still dispatch the event
  if (!foundItem) {
    document.dispatchEvent(
      new CustomEvent("line-item:update", {
        detail: { id, isSpinner, quantity },
      }),
    );
  }
};

/**
 * Remove item from cart
 */
const removeItem = (id, { isSpinner }) => {
  const lineItems = document.querySelectorAll(".line-item");
  let foundItem = false;

  // Find the item in the cart and remove it
  for (const lineItem of lineItems) {
    const imagewrapper = lineItem.querySelector(".line-item__image-wrapper");
    if (!imagewrapper) continue;

    const href = imagewrapper.href;
    if (href.indexOf(`?variant=${id}`) !== -1) {
      foundItem = true;
      const removeButton = lineItem.querySelector(".line-item__remove-button");
      removeButton.click();

      // Monitor for removal completion
      const removalMonitor = setInterval(() => {
        const cartDrawer = removeButton.closest(".mini-cart");
        if (!cartDrawer) {
          clearInterval(removalMonitor);
          document.dispatchEvent(
            new CustomEvent("line-item:update", {
              detail: { id, isSpinner, quantity: 0 },
            }),
          );
        }
      }, 100);

      break;
    }
  }

  // If the item wasn't found in the cart, still dispatch the event
  if (!foundItem) {
    document.dispatchEvent(
      new CustomEvent("line-item:update", {
        detail: { id, isSpinner, quantity: 0 },
      }),
    );
  }
};

/**
 * Add item to cart
 */
const addToCart = async (id, { isSpinner, quantity }) => {
  const spinner = document.querySelector(`.spinner-atc[variant_id="${id}"]`);
  if (!spinner) return;

  try {
    const formData = new FormData();
    formData.set("id", id);
    formData.set("quantity", 1);
    formData.append("sections", ["mini-cart"]);

    // First request: Add to cart
    const response = await fetch(
      `${window.themeVariables.routes.cartAddUrl}.js`,
      {
        body: formData,
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      },
    );

    const responseJson = await response.json();

    // Process the response regardless of success/failure
    if (response.ok) {
      // Special case for cart page
      if (
        window.themeVariables.settings.cartType === "page" ||
        window.themeVariables.settings.pageType === "cart"
      ) {
        window.location.href = `${Shopify.routes.root}cart`;
        return;
      }

      // Second request: Get updated cart
      fetch(`${window.themeVariables.routes.cartUrl}.js`).then(
        async (response2) => {
          const cartContent = await response2.json();

          // Trigger cart update events
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:updated", {
              bubbles: true,
              detail: { cart: cartContent },
            }),
          );

          cartContent["sections"] = responseJson["sections"];
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: cartContent,
                openMiniCart:
                  window.themeVariables.settings.cartType === "drawer",
              },
            }),
          );

          // Update spinner on success
          document.dispatchEvent(
            new CustomEvent("line-item:update", {
              detail: {
                id,
                isSpinner,
                quantity,
                added: true,
              },
            }),
          );

          // Show success notification
          showNotification("success", "");
        },
      );
    } else {
      // On error, reset the spinner state and show error
      if (spinner) {
        // Use the error message from API or fallback to general error
        const errorMessage =
          responseJson["description"] || getTranslation(spinner, "cart-error");

        showNotification("error", errorMessage);

        spinner.classList.remove("loading");
        spinner.querySelector(".atc")?.classList.add("show");
        spinner
          .querySelector(".quantity-input-by-spinner")
          ?.classList.remove("show");
        spinner.querySelector(".quantity-by-input")?.classList.remove("show");
      }
    }

    // Reset button state after delay (matching theme's approach but shorter)
    setTimeout(() => {
      if (spinner) {
        spinner.classList.remove("loading");
      }
    }, 1000); // Using 1 second instead of 3.7 seconds for better UX
  } catch (error) {
    console.error("Error adding to cart:", error);
    // Reset spinner state on error
    if (spinner) {
      const errorMessage = getTranslation(spinner, "cart-error");
      showNotification("error", errorMessage);

      spinner.classList.remove("loading");
      spinner.querySelector(".atc")?.classList.add("show");
      spinner
        .querySelector(".quantity-input-by-spinner")
        ?.classList.remove("show");
      spinner.querySelector(".quantity-by-input")?.classList.remove("show");
    }
  }
};

/**
 * Handle line item update events
 */
document.addEventListener("line-item:update", (e) => {
  const spinner = document.querySelector(
    `.spinner-atc[variant_id="${e.detail.id}"]`,
  );
  if (!spinner) return;

  // Remove loading state
  spinner.classList.remove("loading");

  const quantityLabel = spinner.querySelector("p.quantity");
  const quantityInput = spinner.querySelector("input.quantity");

  if (!quantityInput || !quantityLabel) return;

  // Update quantity displays
  quantityLabel.setAttribute("value", e.detail.quantity);
  quantityLabel.innerHTML = e.detail.quantity;
  quantityInput.value = e.detail.quantity;

  // Update UI based on quantity
  if (e.detail.quantity === 0) {
    // Show "Add to Cart" buttons when quantity is 0
    // Handle both desktop and mobile buttons
    const desktopButton = spinner.querySelector(".atc.hidden-touch");
    const mobileButton = spinner.querySelector(
      ".atc.product-item__quick-buy-button.hidden-no-touch",
    );

    if (desktopButton) desktopButton.classList.add("show");
    if (mobileButton) mobileButton.classList.add("show");

    if (e.detail.isSpinner) {
      spinner
        .querySelector(".quantity-input-by-spinner")
        ?.classList.remove("show");
    } else {
      spinner.querySelector(".quantity-by-input")?.classList.remove("show");
    }
  } else {
    if (e.detail.added) {
      // Item was just added to cart
      const desktopButton = spinner.querySelector(".atc.hidden-touch");
      const mobileButton = spinner.querySelector(
        ".atc.product-item__quick-buy-button.hidden-no-touch",
      );

      if (desktopButton) desktopButton.classList.remove("show");
      if (mobileButton) mobileButton.classList.remove("show");

      spinner
        .querySelector(".quantity-input-by-spinner")
        ?.classList.add("show");
    } else if (!e.detail.isSpinner) {
      // Direct input mode completed
      spinner
        .querySelector(".quantity-input-by-spinner")
        ?.classList.add("show");
      spinner.querySelector(".quantity-by-input")?.classList.remove("show");
    }
  }
});

/**
 * Handle cart rendered event
 */
document.addEventListener("cart:rendered", () => {
  // Sync spinner states with cart
  const lineItems = document.querySelectorAll(".line-item");

  for (const lineItem of lineItems) {
    const imagewrapper = lineItem.querySelector(".line-item__image-wrapper");
    if (!imagewrapper) continue;

    const href = imagewrapper.href;
    const i = href.indexOf(`?variant=`);

    if (i === -1) continue;

    const id = href.substring(i + 9);
    const spinner = document.querySelector(`.spinner-atc[variant_id="${id}"]`);

    if (!spinner) continue;

    const quantityInput = lineItem.querySelector(".quantity-selector__input");
    if (!quantityInput) continue;

    const quantity = parseInt(quantityInput.value);
    updateQuantity(quantity, spinner, false, 0);
  }
});

/**
 * Filter function to show only specific filters (Bio, Glutenfrei, Vegan)
 * Works with multiple languages
 */
function filterAllowedFilters() {
  // Define allowed filter terms in multiple languages
  const allowedTerms = [
    // German
    'bio', 'Bio', 'glutenfrei', 'Glutenfrei', 'vegan', 'Vegan',
    // English
    'organic', 'Organic', 'gluten-free', 'Gluten-free', 'vegan', 'Vegan',
    // French
    'bio', 'Bio', 'sans gluten', 'Sans gluten', 'végétalien', 'Végétalien',
    // Italian
    'biologico', 'Biologico', 'senza glutine', 'Senza glutine', 'vegano', 'Vegano',
    // Spanish
    'orgánico', 'Orgánico', 'sin gluten', 'Sin gluten', 'vegano', 'Vegano'
  ];

  // Find all filter containers
  const filterContainers = document.querySelectorAll('.product-facet__filter-item .checkbox-container');
  
  filterContainers.forEach(container => {
    const label = container.querySelector('label');
    if (label) {
      const labelText = label.textContent.trim();
      
      // Check if the label contains any of the allowed terms
      const isAllowed = allowedTerms.some(term => 
        labelText.toLowerCase().includes(term.toLowerCase())
      );
      
      if (isAllowed) {
        container.classList.add('allowed-filter');
      }
    }
  });
}

// Run filter function when DOM is loaded
document.addEventListener('DOMContentLoaded', filterAllowedFilters);

// Run filter function when filters are updated (for dynamic content)
document.addEventListener('facet:updated', filterAllowedFilters);

// Also run on page load and after any AJAX updates
window.addEventListener('load', filterAllowedFilters);

// Run periodically to catch dynamically loaded filters
setInterval(filterAllowedFilters, 2000);



  (function () {
    function hideUpsellQty() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          cart.items.forEach(function (item) {
            if (!item.properties || item.properties['_upsell'] !== 'true') return;
            var input = document.querySelector(
              'cart-drawer [name="updates[' + item.key + ']"]'
            );
            if (!input) return;
            var qs = input.closest('.quantity-selector');
            if (qs) qs.style.display = 'none';
          });
        });
    }

    document.addEventListener('DOMContentLoaded', hideUpsellQty);
    // Re-run when cart drawer re-rendert (Dawn / Impulse etc.)
    document.addEventListener('cart:refresh', hideUpsellQty);
    document.addEventListener('cart:updated', hideUpsellQty);

    // Fallback: MutationObserver falls keine cart-Events gefeuert werden
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) { hideUpsellQty(); break; }
      }
    });
    document.addEventListener('DOMContentLoaded', function () {
      var drawer = document.querySelector('cart-drawer');
      if (drawer) observer.observe(drawer, { childList: true, subtree: true });
    });
  })();
  